import { COLORS, SIZE } from '@tm/shared'

function hex(n) {
  return '#' + n.toString(16).padStart(6, '0')
}

export function createIconButton({ icon, label, onClick, ariaLabel, dataset }) {
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.setAttribute('aria-label', ariaLabel || label)
  btn.title = label
  if (dataset && typeof dataset === 'object') {
    Object.entries(dataset).forEach(([k, v]) => {
      btn.dataset[k] = v
    })
  }
  btn.innerHTML = `
    <span aria-hidden="true" style="font-size:24px;line-height:1;">${icon}</span>
    <span class="sr-only">${label}</span>
  `
  btn.style.cssText = [
    `min-width:${SIZE.minTapTargetDp}px`,
    `min-height:${SIZE.minTapTargetDp}px`,
    `border:2px solid ${hex(COLORS.ink)}`,
    `background:${hex(COLORS.paper)}`,
    'border-radius:14px',
    'cursor:pointer',
    `font-family:${'"Quicksand","Nunito",system-ui,sans-serif'}`,
    'display:inline-flex',
    'align-items:center',
    'justify-content:center',
    'touch-action:manipulation',
    'user-select:none',
    '-webkit-tap-highlight-color:transparent',
  ].join(';')
  if (typeof onClick === 'function') btn.addEventListener('click', onClick)
  return btn
}
